import { Moment } from 'moment';
import { DateTimeUtilsService } from '../services/date-time-utils.service';

export class UpdateActuationModel {

    public fecha: string;

    constructor(
        fecha: Moment,
        public comentarios: string,
        public comentariosEmpresa: string,
        public autor: string,
        public tipoAutor: string,
        public medicoId: number,
    ) {
        const dateUtils = new DateTimeUtilsService();
        this.fecha = dateUtils.convertMomentForBackend(fecha);
    }

}